export function mapOrder(array: number[], order: number[]) {
  array.sort((a, b) => {
    if (order.indexOf(a) > order.indexOf(b)) {
      return 1;
    } else {
      return -1;
    }
  });

  return array;
}
